import { paymentSlipStrings } from '@data/paymentSlip';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${paymentSlipStrings.payment_slip}一覧`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 2,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
